import { BaseIndex } from "../BaseIndex";
export class BooleanIndex extends BaseIndex {
    constructor(getSource, transform) {
        super(getSource, transform);
        this.defaultValue = false;
    }
}
//# sourceMappingURL=BooleanIndex.js.map